import { render, staticRenderFns } from "./v-catalogMain-item.vue?vue&type=template&id=ed146f98&"
import script from "./v-catalogMain-item.vue?vue&type=script&lang=js&"
export * from "./v-catalogMain-item.vue?vue&type=script&lang=js&"
import style0 from "./v-catalogMain-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports